import { Button, Group, Text, TextInput } from '@mantine/core';
import AwesomeDebouncePromise from 'awesome-debounce-promise';
import queryString from 'query-string';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import Regex from '../../constants/Regex';
import useFetch from '../../helpers/useFetch';
import ErrorMessage from '../ErrorMessage';
import Spinner from '../Spinner';
import AssetPickerCard from './AssetPickerCard';

const fetchDebounced = AwesomeDebouncePromise((fetch, accountId, domainId, searchTerms, tab) => {
  const query = queryString.stringify({ searchTerms, tab }, { skipEmptyString: true });
  return fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/assets${query ? `?${query}` : ''}`);
}, 300);

const AssetsPage = ({ addAsset, pickUrl, cancel, tab, assetFilter }) => {
  const [error, setError] = useState();
  const [searchTerms, setSearchTerms] = useState();
  const [siteUrl, setSiteUrl] = useState();
  const [assets, setAssets] = useState();
  const { accountId, domainId } = useParams();

  const fetch = useFetch();

  useEffect(() => {
    fetchDebounced(fetch, accountId, domainId, searchTerms, tab)
      .then(({ assets }) => {
        setAssets(assets);
      })
      .catch(setError);
  }, [accountId, domainId, searchTerms, tab, fetch]);

  const onSearchClick = (value) => {
    setSearchTerms(value);
  };

  if (error) {
    return <ErrorMessage message={error.message} />;
  }

  if (!assets) {
    return <Spinner />;
  }

  const assetElements = (assetFilter ? assets.filter(assetFilter) : assets).map((asset) => (
    <AssetPickerCard key={asset.id} asset={asset} addAsset={(asset) => addAsset(asset, siteUrl)} />
  ));

  return (
    <>
      {pickUrl ? (
        <>
          <Text size="sm" c="dimmed">
            Link URL (Optional)
          </Text>
          <TextInput
            name="siteUrl"
            type="text"
            value={siteUrl}
            placeholder="https://myawesomeshop.com/landing/page"
            error={siteUrl && !siteUrl.match(Regex.urlRegex) ? 'Valid URL or empty  field is required.' : null}
            onChange={(e) => setSiteUrl(e.target.value)}
            mb="md"
          />
        </>
      ) : (
        ''
      )}
      <Text size="sm" c="dimmed" mb="xs">
        {tab === 'documents' ? 'Search and select a document' : 'Search and select an image'}
      </Text>
      <TextInput
        onKeyUp={(event) => onSearchClick(event.target.value)}
        type="search"
        placeholder="Search"
        mr="xs"
        aria-label="Search"
        mb="md"
      />
      {assetElements}

      <Group justify="flex-end" gap="xs" py="md">
        <Button variant="default" onClick={() => cancel()} mb="sm">
          {' '}
          Cancel
        </Button>
      </Group>
    </>
  );
};

export default AssetsPage;
